import { render, staticRenderFns } from "./manageBanner.vue?vue&type=template&id=197e3f57&scoped=true&"
import script from "./manageBanner.vue?vue&type=script&lang=js&"
export * from "./manageBanner.vue?vue&type=script&lang=js&"
import style0 from "./manageBanner.vue?vue&type=style&index=0&id=197e3f57&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197e3f57",
  null
  
)

export default component.exports